import React from 'react'
import {
  CollegeInfoContainer,
  CollegeLogoContainer,
  CollegeTextContainer,
  CollegeNameText,
  CollegeCityText
} from './styles'

const LetterAvatar = ({ name }) => {
  const letter = (name || '?').trim().charAt(0).toUpperCase()
  return (
    <div style={{
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#3249D7',
      color: '#fff',
      fontWeight: 700,
      fontSize: 18,
      borderRadius: 8,
    }}>
      {letter}
    </div>
  )
}

const CollegeCard = ({ name, city, logoUrl }) => {
  return (
    <CollegeInfoContainer>
      <CollegeLogoContainer>
        {logoUrl ? <img src={logoUrl} alt={name} /> : <LetterAvatar name={name} />}
      </CollegeLogoContainer>
      <CollegeTextContainer>
        <CollegeNameText>{name}</CollegeNameText>
        <CollegeCityText>{city}</CollegeCityText>
      </CollegeTextContainer>
    </CollegeInfoContainer>
  )
}

export default CollegeCard
